import 'focus-visible/dist/focus-visible';
import React from 'react';
import { render } from 'react-dom';
import { Alert } from '../../CommonComponents/OPL/Alert/Alert';
import { Button } from '../../CommonComponents/OPL/Button/Button';
import { Icon } from '../../CommonComponents/OPL/Icon/Icon';
import { Input } from '../../CommonComponents/OPL/Input/Input';
import { Link } from '../../CommonComponents/OPL/Link/Link';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { AuthWrapper } from '../components/AuthWrapper/AuthWrapper';
import { RequestPasswordResetFormStep } from './RequestPasswordReset.meta';
import { useRequestPasswordReset } from './useRequestPasswordReset';
import { AuthProviders } from '../components/AuthProviders/AuthProviders';

const RequestPasswordReset = () => {
  const {
    onSubmit,
    email,
    register,
    formState,
    backendError,
    step,
    logoUrl,
    assetsEndpoint,
    termsAndConditionsUrl,
  } = useRequestPasswordReset();

  return (
    <AuthWrapper
      logoUrl={logoUrl}
      assetsEndpoint={assetsEndpoint}
      termsAndConditionsUrl={termsAndConditionsUrl}
    >
      <form onSubmit={onSubmit} aria-label="Request password reset">
        <Link mb="24" href="/" target="_self">
          <Icon className="fas fa-arrow-left" mr="8" />
          Back to Login
        </Link>

        {backendError && (
          <Alert variant="warning" mb="16">
            {backendError}
          </Alert>
        )}

        <Text as="h1" fontSize="h4" fontWeight={600} mb="16">
          {step === RequestPasswordResetFormStep.Email && 'Reset Password'}
          {step === RequestPasswordResetFormStep.LinkInstructions && 'Please Check Your Email'}
        </Text>

        {step === RequestPasswordResetFormStep.Email && (
          <>
            <Text as="p" color="neutral.500" mb="24">
              Enter your username or email and we’ll send you instructions to reset your password.
            </Text>

            <Input
              {...register('email')}
              label="Email or Username"
              formVariant={formState.errors.email && 'error'}
              helperText={formState.errors.email?.message}
            />
          </>
        )}

        {step === RequestPasswordResetFormStep.LinkInstructions && (
          <>
            <Text as="p" mb="24">
              If <strong>{email}</strong> is associated with your account, we’ll send you a link to
              change your password.
            </Text>
            <Text as="p">
              It could take a few minutes to appear. Be sure to check any spam and promotional
              folders — just in case!
            </Text>
          </>
        )}

        {step === RequestPasswordResetFormStep.Email && (
          <>
            <Button mt="32" mb="24" width="100%" isLoading={formState.isSubmitting} type="submit">
              Reset Password
            </Button>

            <Text as="p" color="neutral.500" fontSize="small">
              Still having trouble logging in? Please reach out to your administrator.
            </Text>
          </>
        )}
      </form>
    </AuthWrapper>
  );
};

render(
  <AuthProviders>
    <RequestPasswordReset />
  </AuthProviders>,
  document.getElementById('app'),
);
